// Static UI copy used across pages
export const PRODUCT_DESCRIPTION = `Hydro Health peptides are independently lab-tested using our extended analytical panel. Each batch undergoes identity & purity verification, heavy metals screening, endotoxin testing, microbial safety analysis, and structural integrity assessment.

NOT FOR RESALE OR HUMAN CONSUMPTION — RESEARCH PURPOSES ONLY`;
